import { checkAuth } from "../../../Utils/CheckAuthentication";
import { TOKEN_KEY } from "../../../Utils/Constants";
import { baseUrl } from "../../../shared/baseUrl";
import { createNotification } from "../../Common/CreateNotification";

export const fetchSellers = async () => {
  try {
    const data = await fetch(baseUrl + `chat/sellers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          localStorage.getItem(TOKEN_KEY) !== null
            ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            : null,
      },
    }).then((res) => checkAuth(res));
    if (data.success) {
      return data
    } else {
      createNotification("error", "Error in loading Sellers");
      return [];
    }
  } catch (error) {
    createNotification("error fetching data", error);
  }
};

export const fetchChatSellers = async ({ id, page }) => {
  try {
    const res = await fetch(baseUrl + `chat/sellers/${id}?page=${page}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          localStorage.getItem(TOKEN_KEY) !== null
            ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            : null,
      },
    });
    const data = await res.json();
    if (data.success) {
      return data.data;
    } else {
      createNotification("error", "Error in loading Sellers");
      return [];
    }
  } catch (error) {
    createNotification("error fetching data", error);
  }
};
